import styled from 'styled-components'
import { inputStyles } from 'components/generic/Input/styles'

export const TextArea = styled.textarea`
  ${inputStyles}
  height: auto;
  padding: 1rem;
`
export const Description = styled.span`
  color: ${({ theme }) => theme.colors.textColor};
  display: block;
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  margin-bottom: 8px;
`
